module.exports = __webpack_public_path__ + "img/icon_3d_tip.27ede3ce.png";